export default {
  host: 'http://api.joenix.com',
};
